/**
 * DropPageStates — loading + error skeletons for DropPage.
 *
 * Extracted from DropPage.tsx to keep that file under the 400-line ceiling.
 * Both states are pure presentational components — no state of their own.
 */

import React from "react";
import {useNavigate} from "react-router";
import Skeleton from "react-loading-skeleton";
import {Button} from "@/components/buttons/Button";

export const DropPageLoading: React.FC = () =>
    <div className="drop-page drop-page--loading">
        <div className="drop-page__skeleton-header">
            <Skeleton height={60} />
        </div>
        <div className="drop-page__skeleton-hero">
            <Skeleton height={400} />
        </div>
        <div className="drop-page__skeleton-nav">
            <Skeleton height={60} />
        </div>
        <div className="drop-page__skeleton-content">
            <Skeleton height={300} />
        </div>
    </div>;

/**
 * Error state for an unresolvable Drop (404 or backend error).
 *
 * The CTA navigates to `/play` rather than `/drop-in`. Reasoning: a Drop
 * URL is most often hit from a deeplink shared in DMs / social / email,
 * not from inside the Drop-In directory. Routing back to /drop-in would
 * confuse those users (they may not have visited Drop-In before). /play
 * is the canonical "home" of the authenticated app and gives the user a
 * familiar surface to recover on.
 */
export const DropPageError: React.FC = () => {
    const navigate = useNavigate();
    return (
        <div className="drop-page drop-page--error">
            <div className="drop-page__error">
                <h1>Drop Not Found</h1>
                <p>The creator or community page you're looking for doesn't exist or is not currently active.</p>
                <Button variant="primary" onClick={() => navigate("/play")}>
                    Go to DevourPlay
                </Button>
            </div>
        </div>
    );
};
